import type { ConnectionMeter } from "@shared/api/generated/model";
import { Tag } from "antd";
import type { ColumnsType } from "antd/es/table";

/** Базовые колонки счётчика соединения — используются в drawer-вкладке "Устройства" и в expanded row. */
export const connectionMeterColumns: ColumnsType<ConnectionMeter> = [
  { title: "ID", dataIndex: "id", width: 80 },
  {
    title: "Название",
    dataIndex: "name",
    width: 150,
    ellipsis: true,
    render: (v?: string | null) => v || "—",
  },
  {
    title: "Серийный номер",
    dataIndex: "serial_number",
    width: 130,
    render: (v?: string | null) => v || "—",
  },
  {
    title: "Адрес",
    dataIndex: "address",
    width: 80,
    render: (v?: number | null) => v ?? "—",
  },
  {
    title: "Интервал опроса",
    dataIndex: "poll_interval",
    width: 120,
    render: (v?: string | null) => (v ? <Tag color="blue">{v}</Tag> : "—"),
  },
  {
    title: "Статус",
    dataIndex: "status",
    width: 80,
    render: (v?: number | null) =>
      v === 1 ? <Tag color="green">Акт</Tag> : <Tag color="default">Неакт</Tag>,
  },
  {
    title: "Последний опрос",
    dataIndex: "last_poll_time",
    width: 160,
    render: (v?: string | null) => v || "—",
  },
  {
    title: "Расхождение",
    dataIndex: "time_delta",
    width: 100,
    render: (v?: number | null) => {
      if (v === undefined || v === null) return "—";
      const abs = Math.abs(v);
      const color = abs > 60 ? "red" : abs > 10 ? "orange" : "green";
      return <Tag color={color}>{v} сек</Tag>;
    },
  },
  {
    title: "Объект",
    dataIndex: "object_name",
    width: 180,
    render: (v?: string | null, row?: ConnectionMeter) => {
      if (v) {
        return (
          <Tag>
            {v} ({row?.region_id}/{row?.object_id})
          </Tag>
        );
      }
      if (row?.region_id && row?.object_id) {
        return <Tag>{`${row.region_id}/${row.object_id}`}</Tag>;
      }
      return "—";
    },
  },
];
